import React, { forwardRef } from 'react';
import styled from 'styled-components';
import MUIAlert from '@material-ui/lab/Alert';

import { Text } from 'Components/Base';

const StyledMUIAlert = styled(MUIAlert)(({ theme, color }) => {
  return {
    '&&': !color && {
      background: theme.colors?.snackbarBackground ?? '#262626',
    },
    '& .MuiAlert-message': {
      color: 'white',
    },
  };
});

const Alert = (props, ref) => {
  const { children, action, icon, ...restProps } = props;

  return (
    <StyledMUIAlert ref={ref} icon={icon || false} variant="filled" action={action} {...restProps}>
      {typeof children === 'string' ? (
        <Text fontWeight={action ? 'semibold' : 'normal'} fontSize={1}>
          {children}
        </Text>
      ) : (
        children
      )}
    </StyledMUIAlert>
  );
};

export default forwardRef(Alert);
